var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false)?_c('Video'):_vm._e(),(false)?_c('Picture'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }